import React from 'react';
import isEmpty from 'lodash/isEmpty';

import ExtrusionLayer from './ExtrusionLayer';
import LineLayer from './LineLayer';
import SelectedExtrusionLayer from './SelectedExtrusionLayer';
import SelectedLineLayer from './SelectedLineLayer';

const Layers = ({ data }) => {
	if (isEmpty(data)) return null;
	return [
		LineLayer(data),
		SelectedLineLayer(data),
		ExtrusionLayer(data),
		SelectedExtrusionLayer(data),
	]
}


export default Layers;